import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
export function KpiStrip({ items, className }) {
    return (<Card className={cn('border-border/60 bg-card/40 backdrop-blur-sm', className)}>
            <CardContent className="grid divide-y divide-border/40 p-0 sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:grid-cols-4">
                {items.map((item, i) => (<div key={i} className="flex items-start justify-between gap-3 p-4">
                        <div className="min-w-0 space-y-1">
                            <p className="text-xs uppercase tracking-wide text-muted-foreground">{item.label}</p>
                            <p className="text-xl font-semibold tabular-nums text-foreground sm:text-2xl">
                                {item.value}
                            </p>
                            {item.hint ? <p className="truncate text-xs text-muted-foreground">{item.hint}</p> : null}
                        </div>
                        {item.icon ? <div className="text-muted-foreground/70">{item.icon}</div> : null}
                    </div>))}
            </CardContent>
        </Card>);
}
